module.exports = __webpack_public_path__ + "img/bx-current-location-1.2f84fead.svg";